export default "__VITE_ASSET__DEM9uGS6__"